import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import icons from '@loggi/ui/components/utils/icons';
import colors from '@loggi/ui/components/utils/colors';

const ICONS_NAMES = icons.names;
const COLORS_NAMES = colors.hexKeys;
const NativeIcon = __NATIVE__ ? require('./native').default : null;

export default function Icon(props) {
  const { type, className, style, color } = props;
  const colorStyle = color ? { color: colors.hex[color] } : null;
  const inlineStyle =
    color || style ? Object.assign({}, style, colorStyle) : style;

  if (NativeIcon) {
    return (
      <NativeIcon
        name={type}
        style={inlineStyle}
        size={style ? style.fontSize : null}
        {...colorStyle}
      />
    );
  }

  const iconClasses = classNames([
    'ico',
    [`ico-${type}`],
    { [className]: className }
  ]);

  return <i className={iconClasses} style={inlineStyle} />;
}

Icon.displayName = 'Icon';

Icon.propTypes = {
  type: __NATIVE__
    ? PropTypes.string.isRequired
    : PropTypes.oneOf(ICONS_NAMES).isRequired,
  color: __NATIVE__ ? PropTypes.string : PropTypes.oneOf(COLORS_NAMES),
  style: PropTypes.object,
  className: PropTypes.string
};

Icon.defaultProps = {
  color: null,
  style: null,
  className: null
};
